function calculateCartPrices({ unitPrice, quantity }) {
  const normalizedUnitPrice = Number(unitPrice);
  const normalizedQuantity = Number(quantity);

  if (!Number.isFinite(normalizedUnitPrice) || normalizedUnitPrice <= 0) {
    throw new Error("A positive price is required");
  }
  if (!Number.isInteger(normalizedQuantity) || normalizedQuantity <= 0) {
    throw new Error("Quantity must be a positive whole number");
  }

  return {
    variantUnitPrice: normalizedUnitPrice.toFixed(2),
    displayedTotal: (normalizedUnitPrice * normalizedQuantity).toFixed(2),
  };
}

export { calculateCartPrices };
